import { Box, Text } from '@chakra-ui/react';

export const SwitchPreview = () => {
  return (
    <Box>
      <Text>SwitchPreview - Coming soon</Text>
    </Box>
  );
};
